// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"977d9b90","495":"cf2ffde9","555":"409f3c0b","615":"efc04ce6","900":"20c88bad"}[chunkId] + ".chunk.js";
};